<template>
  <div>
    <div class="header">
      <div style="margin-bottom: 10px">
        <el-button v-if="urge_type===2" size="mini" @click="openLegalCase">录入催费案件</el-button>
        <el-button size="mini" @click="exportData(0)">导出表格</el-button>
        <el-button size="mini" @click="exportData(1)">导出资料</el-button>
      </div>
      <div style="margin-bottom: 10px">
        <el-select size="mini" placeholder="账龄类型" clearable v-model="where2.age">
          <el-option :value="5" label="1年以上"></el-option>
        </el-select>
<!--        <el-date-picker-->
<!--          style="width: 120px"-->
<!--          v-model="where2.qf_time"-->
<!--          size="mini"-->
<!--          type="month"-->
<!--          format="yyyy-MM"-->
<!--          value-format="yyyy-MM" placeholder="欠费月份">-->
<!--        </el-date-picker>-->
<!--        <el-date-picker-->
<!--          style="width: 120px"-->
<!--          v-model="where2.last_month"-->
<!--          size="mini"-->
<!--          type="month"-->
<!--          format="yyyy-MM"-->
<!--          value-format="yyyy-MM" placeholder="上次缴费月份">-->
<!--        </el-date-picker>-->

        <el-date-picker
          style="width: 150px"
          v-model="where2.gj_time"
          size="mini"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd" placeholder="跟进日期">
        </el-date-picker>
        <el-input clearable placeholder="欠费月数" v-model="where2.month_count" style="width: 100px" size="mini"></el-input>
        <el-select size="mini" placeholder="月催费次数" clearable v-model="where2.cur_month_times" style="width: 120px;">
          <el-option :value="0" label="暂未催费"></el-option>
          <el-option :value="1" label="1次催费"></el-option>
          <el-option :value="2" label="2次催费"></el-option>
          <el-option :value="3" label="3次催费"></el-option>
          <el-option :value="4" label="多次催费"></el-option>
        </el-select>
        <el-select size="mini" placeholder="年催费次数" clearable v-model="where2.cur_year_times" style="width: 120px;">
          <el-option :value="0" label="暂未催费"></el-option>
          <el-option :value="1" label="1次催费"></el-option>
          <el-option :value="2" label="2次催费"></el-option>
          <el-option :value="3" label="3次催费"></el-option>
          <el-option :value="4" label="多次催费"></el-option>
        </el-select>
        <el-select size="mini" placeholder="选择房态" clearable v-model="where2.room_status" style="width: 120px;">
          <el-option :value="1" label="空置"></el-option>
          <el-option :value="2" label="未领"></el-option>
          <el-option :value="3" label="空关"></el-option>
          <el-option :value="4" label="装修"></el-option>
          <el-option :value="5" label="入住"></el-option>
          <el-option :value="6" label="出租"></el-option>
          <el-option :value="7" label="停用"></el-option>
        </el-select>
        <el-select size="mini" placeholder="信息完整" clearable v-model="where2.is_complete" style="width: 120px;">
          <el-option value="1" label="完整"></el-option>
          <el-option value="0" label="未完整"></el-option>
        </el-select>
        <el-select size="mini" placeholder="是否已立案" clearable v-model="where2.is_case" style="width: 120px;">
          <el-option value="1" label="是"></el-option>
          <el-option value="0" label="否"></el-option>
        </el-select>
        <el-select size="mini" placeholder="是否可立案" clearable v-model="where2.is_apply" style="width: 120px;">
          <el-option value="1" label="是"></el-option>
          <el-option value="0" label="否"></el-option>
        </el-select>
        <el-select size="mini" placeholder="欠费类型" clearable v-model="where2.arrears_level1" style="width: 180px;" @change="changeArrearsLevel1">
          <el-option v-for="(item, index) in arrears_arr" :key="index" :value="item.id" :label="item.name"></el-option>
        </el-select>
        <el-select size="mini" placeholder="欠费类型-原因" clearable v-model="where2.arrears_level2" style="width: 180px;">
          <el-option v-for="(item, index) in arrears_arr_children" :key="index" :value="item.id" :label="item.name"></el-option>
        </el-select>
        <el-input clearable placeholder="输入房产" v-model="where2.house_name" style="width: 200px" size="mini"></el-input>
      </div>
    </div>
    <AgeTip
      v-if="where2.age"
      :project_id="reginWhere.project_name"
      :project_ids="reginWhere.project_ids"
      :ages="[where2.age]"
    >
    <template slot="start">
      催费房产数：{{pageData.total}} &nbsp;&nbsp;&nbsp;&nbsp;
      提交户数：{{statistic.tj_num}} &nbsp;&nbsp;&nbsp;&nbsp;
      诉调户数：{{statistic.st_num}} &nbsp;&nbsp;&nbsp;&nbsp;
      立案户数：{{statistic.la_num}} &nbsp;&nbsp;&nbsp;&nbsp;
      信息完整户数：{{statistic.complete_num}} &nbsp;&nbsp;&nbsp;&nbsp;
<!--      已立案户数：{{statistic.case_num}} &nbsp;&nbsp;&nbsp;&nbsp;-->
      可立案户数：{{statistic.apply_num}} &nbsp;&nbsp;&nbsp;&nbsp;
    </template>
      <span slot="default">

    </span>
    </AgeTip>
    <div class="table-container">
      <el-table
        v-loading="loading"
        :data="pageData.data"
        @selection-change="handleSelectionChange"
        border
        style="width: 100%"
        height="calc(100vh - 530px)">
        <el-table-column type="selection" width="45" fixed></el-table-column>
        <el-table-column
          prop="房产信息"
          label="房产信息" width="320" fixed></el-table-column>
        <el-table-column label="诉讼所需信息" align="center">
          <el-table-column
            prop="customer_type"
            label="客户类型"
            width="90" align="center">
            <template slot-scope="scope">
              {{scope.row.customer_type===1? '个人' : '企业'}}
            </template>
          </el-table-column>
          <el-table-column
            prop="业主"
            label="业主姓名"
            width="220" align="center">
          </el-table-column>
          <el-table-column
            prop="业主电话"
            label="业主电话"
            width="150" align="center">
          </el-table-column>
          <el-table-column
            prop="credentials_code"
            label="身份证/组织机构代码"
            width="200" align="center">
          </el-table-column>
          <el-table-column
            prop="credentials_file"
            label="证件（身份证/营业执照）"
            width="180" align="center">
            <template slot-scope="scope">
              <el-row>
                <el-col :span="12">
                  <el-link type="primary" @click="uploadFile(scope.row,'credentials_file')">上传证件</el-link>
                </el-col>
                <el-col :span="12">
                  <el-link type="primary" v-if="scope.row.credentials_file" @click="viewFile(scope.row,'credentials_file')">查看证件</el-link>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="诉讼所需信息" align="center">
          <el-table-column
            prop="service_contract"
            label="物业服务合同"
            width="180" align="center">
            <template slot-scope="scope">
              <el-row>
                <el-col :span="12">
                  <el-link type="primary" @click="uploadFile(scope.row,'service_contract')">上传合同</el-link>
                </el-col>
                <el-col :span="12">
                  <el-link type="primary" v-if="scope.row.service_contract" @click="viewFile(scope.row,'service_contract')">查看合同</el-link>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
<!--          <el-table-column-->
<!--            prop="room_contract"-->
<!--            label="房屋买卖合同/房屋产权证"-->
<!--            width="180" align="center">-->
<!--            <template slot-scope="scope">-->
<!--              <el-row>-->
<!--                <el-col :span="12">-->
<!--                  <el-link type="primary" @click="uploadFile(scope.row,'room_contract')">上传证件</el-link>-->
<!--                </el-col>-->
<!--                <el-col :span="12">-->
<!--                  <el-link type="primary" v-if="scope.row.room_contract" @click="viewFile(scope.row,'room_contract')">查看证件</el-link>-->
<!--                </el-col>-->
<!--              </el-row>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column
            prop="sms_num"
            label="短信催收记录"
            width="120" align="center">
          </el-table-column>
          <el-table-column
            prop="ems_num"
            label="催收函及其邮寄凭证"
            width="150" align="center">
          </el-table-column>
        </el-table-column>
        <el-table-column
          prop="complete_rate"
          label="完整率"
          width="90" align="center"></el-table-column>
        <el-table-column
          prop="la_num"
          label="是否完整"
          width="90" align="center">
          <template slot-scope="scope">
            {{scope.row.is_complete? '完整' : '否'}}
          </template>
        </el-table-column>
        <el-table-column label="历史诉讼情况" align="center">
          <el-table-column
            prop="tj_num"
            label="提交"
            width="90" align="center">
          </el-table-column>
          <el-table-column
            prop="st_num"
            label="诉调"
            width="90" align="center">
          </el-table-column>
          <el-table-column
            prop="la_num"
            label="立案"
            width="90" align="center">
          </el-table-column>
        </el-table-column>
<!--        <el-table-column-->
<!--          prop="is_case"-->
<!--          label="是否已立案"-->
<!--          width="90" align="center">-->
<!--          <template slot-scope="scope">-->
<!--            {{scope.row.is_case? '立案' : '否'}}-->
<!--          </template>-->
<!--        </el-table-column>-->

        <el-table-column
          prop="la_num"
          label="可立案状态"
          width="90" align="center" fixed="right">
          <template slot-scope="scope">
            <span v-if="(scope.row.is_complete&&!scope.row.is_case)" style="font-weight: bold;color: #328628;">可</span>
            <span v-if="!(scope.row.is_complete&&!scope.row.is_case)" style="font-weight: bold;color: #fd3a3a;">否</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="房态"
          label="房态"
          width="60">
        </el-table-column>
<!--        <el-table-column-->
<!--          label="银行划扣"-->
<!--          width="90">-->
<!--          <template slot-scope="scope">-->
<!--            <span style="color: #328628" v-if="scope.row.bankType">是</span>-->
<!--            <span v-if="!scope.row.bankType"></span>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="欠费起始月份"-->
<!--          label="欠费起始月份"-->
<!--          width="120">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="欠费月数"-->
<!--          label="欠费月数"-->
<!--          width="100">-->
<!--        </el-table-column>-->
        <el-table-column
          prop="欠费金额/诉讼金额"
          label="欠费金额/诉讼金额"
          width="140">
          <template slot-scope="scope">
            <el-link v-if="scope.row['催缴类型']!=='诉讼'" type="primary" size="mini" @click="getHouseBill(scope.row)">{{ scope.row['欠费金额'] }}</el-link>
            <span v-if="scope.row['催缴类型']==='诉讼'">{{scope.row['诉讼金额']}}</span>
          </template>
        </el-table-column>
<!--        <el-table-column-->
<!--          prop="计划催缴月份"-->
<!--          label="计划催缴月份"-->
<!--          width="100">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="催缴类型"-->
<!--          label="催缴类型"-->
<!--          width="90">-->
<!--        </el-table-column>-->
        <el-table-column
          prop="账龄类型"
          label="账龄类型"
          width="90">
        </el-table-column>
        <el-table-column
          v-if="urge_type===4"
          prop="第三方合作单位"
          label="第三方合作单位"
          width="150">
        </el-table-column>
<!--        <el-table-column-->
<!--          prop="缴费类型"-->
<!--          label="缴费类型"-->
<!--          width="90">-->
<!--        </el-table-column>-->
        <!--          <el-table-column-->
        <!--            prop="上次缴费时间"-->
        <!--            label="上次缴费时间"-->
        <!--            width="170">-->
        <!--            <template slot-scope="scope">-->
        <!--              <el-link type="primary" size="mini" @click="getLastHouseBill(scope.row)">{{ scope.row['上次缴费时间'] }}</el-link>-->
        <!--            </template>-->
        <!--          </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="上次成功缴费方式"-->
<!--          label="上次成功缴费方式"-->
<!--          width="200">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="上次缴费时间"-->
<!--          label="上次缴费时间"-->
<!--          width="170"></el-table-column>-->
        <!--          <el-table-column-->
        <!--            prop="第一次催费时间"-->
        <!--            label="第一次催费时间"-->
        <!--            width="150">-->
        <!--          </el-table-column>-->
        <!--          <el-table-column-->
        <!--            prop="第二次催费时间"-->
        <!--            label="第二次催费时间"-->
        <!--            width="150">-->
        <!--          </el-table-column>-->
        <!--          <el-table-column-->
        <!--            prop="第三次催费时间"-->
        <!--            label="第三次催费时间"-->
        <!--            width="150">-->
        <!--          </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="one_gj_time"-->
<!--          label="第一次催费跟进时间"-->
<!--          width="150">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="two_gj_time"-->
<!--          label="第二次催费跟进时间"-->
<!--          width="150">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="three_gj_time"-->
<!--          label="第三次催费跟进时间"-->
<!--          width="150">-->
<!--        </el-table-column>-->
        <!--          <el-table-column-->
        <!--            prop="催费次数"-->
        <!--            label="催费次数"-->
        <!--            width="90">-->
        <!--          </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="cur_month_times"-->
<!--          label="月催费次数"-->
<!--          width="90">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="cur_year_times"-->
<!--          label="年催费次数"-->
<!--          width="90">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="欠费类型"-->
<!--          label="欠费类型"-->
<!--          width="150">-->
<!--          <template slot-scope="scope">-->
<!--            <span v-if="scope.row['欠费类型']">{{scope.row['欠费类型']}}</span>-->
<!--            <span v-if="scope.row['欠费类型原因']"> ： {{scope.row['欠费类型原因']}}</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="欠费原因"-->
<!--          label="欠费原因"-->
<!--          width="150">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="业主诉求"-->
<!--          label="业主诉求"-->
<!--          width="150">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="解决措施"-->
<!--          label="催费措施"-->
<!--          width="150">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="备注"-->
<!--          label="备注"-->
<!--          width="200">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          label="操作"-->
<!--          width="100" fixed="right">-->
<!--          <template slot-scope="scope">-->
<!--            &lt;!&ndash;              <el-button type="primary" size="mini" @click="editType(scope.row)">变更催缴</el-button>&ndash;&gt;-->
<!--            &lt;!&ndash;              <el-link type="primary" @click="openFlow(scope.row)">审批流程</el-link>&nbsp;&nbsp;&nbsp;&nbsp;&ndash;&gt;-->
<!--            &lt;!&ndash;              <el-button type="danger" size="mini" @click="delHouse(scope.row)">移除</el-button>&ndash;&gt;-->
<!--&lt;!&ndash;            <el-button type="primary" size="mini" @click="addLegalHouse(scope.row)">添加</el-button>&ndash;&gt;-->
<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>
    </div>
    <div class="footer-pagination">
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageData.total" :page-size="pageData.per_page" :current-page="pageData.current_page"
        @current-change="pageChange"
      >
      </el-pagination>
    </div>

    <LegalHouseMoneyList ref="legalHouseMoneyListRef" />
    <ViewFileList ref="viewFileListRef" />
    <LawCaseForm ref="lawCaseForm" :visible="law_case.visible" :house_list="law_case.house_list" :order_type="where2.age"
                 @update="closeLegalCase" >
    </LawCaseForm>
  </div>
</template>

<script>
import moment from "moment/moment";
import AgeTip from "../common/AgeTip";
import LegalHouseMoneyList from "../LegalHouseMoneyList";
import ButlerHttp from "../../common/ButlerHttp";
import {CommonHelp} from "../../common/CommonHelp";
import ViewFileList from "../../../Common/ViewFileList";
import LawCaseForm from '../law_case/case_form.vue'
import {Loading} from "element-ui";

export default {
  name: "LegalHouseCustomer",
  components: {ViewFileList, LegalHouseMoneyList, AgeTip, LawCaseForm},
  props:{
    urge_type:{
      type: Number,
      default(){
        return 2
      }
    },
  },
  inject:['where','reginWhere'],
  data(){
    return{
      where2:{
        urge_type:"",
        age:5,
        type:"",
        cur_month_times:"",
        cur_year_times:"",
        qf_time:moment().format("YYYY-MM"),
        jh_time:'',//moment().format("YYYY-MM"),
        last_month:"",
        house_name:"",
        room_status:"",
        arrears_level1:'',
        arrears_level2:'',
        gj_time:"",
        month_count:"",
        is_complete:"",
        is_case:"",
        is_apply:"",
      },
      loading:false,
      pageData:{
        page: 1,
        per_page: 20,
        data:[],
        total:0
      },
      statistic:{
        count:0,
        tj_num:0,
        st_num:0,
        la_num:0,
        complete_num:0,
        case_num:0,
        apply_num:0
      },
      arrears_arr:[],
      arrears_arr_children:[],
      multipleSelection:[],
      law_case : {
        visible : false ,
        house_list : []
      },
    }
  },
  mounted() {
    const that=this;
    that.where2.urge_type = that.urge_type;
    that.pageChange(1);
    that.getArrearsArr();
  },
  methods: {
    getList(){
      const that=this;
      that.loading=true;
      let where = {
        ...that.where2,
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id
      }
      ButlerHttp.post("HouseCustomer/index?page="+that.pageData.page+"&per_page="+that.pageData.per_page,{
        ...where
      },ret=>{
        that.loading=false;
        if(ret.code){
          that.pageData=ret.data;
        }
      })

      that.pageData.page===1&&that.statisticsFun()
    },
    statisticsFun(){
      const that=this;
      let where = {
        ...that.where2,
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id
      }
      ButlerHttp.post("HouseCustomer/statistics",{
        ...where
      },ret=>{
        if(ret.code){
          that.statistic=ret.data;
        }
      })
    },
    pageChange(i) {
      const that=this;
      that.pageData.page = i;
      CommonHelp.debounce(()=>{
        that.getList()
      },500,that);

    },
    getArrearsArr(){
      const that=this;
      ButlerHttp.get("Legal/getArrearsArr",{},ret=>{
        if(ret.code){
          that.arrears_arr=ret.data;
        }
      })
    },
    getHouseBill(item){
      const that=this;
      // projectId: item.PrecinctID,
      //   houseId: item.HouseID
      that.$refs.legalHouseMoneyListRef.show({
        project_id:item.PrecinctID,
        house_id:item.HouseID,
      })
    },
    changeArrearsLevel1(id){
      const that=this;
      let arrears_index=that.arrears_arr.findIndex(ret=>ret.id===id)
      if(arrears_index!==-1){
        that.arrears_arr_children=that.arrears_arr[arrears_index].children||[];
        that.where2.arrears_level2='';
      }else {
        that.arrears_arr_children=[];
        that.where2.arrears_level2='';
      }
    },
    uploadFile(item,name){
      const that=this;
      that.$refs.viewFileListRef.UploadFile(data=>{
        item[name]=data.FileID
        that.update(item.id,name,data.FileID);
      },item[name]);
    },
    viewFile(item,name){
      const that=this;
      that.$refs.viewFileListRef.show(item[name])
      that.$refs.viewFileListRef.onList(list=>{
        if(list.length===0){
          item[name]="";
          that.update(item.id,name,"");
        }
      })
    },
    update(id,name,value){
      const that=this;
      let data={id:id};
      data[name]=value;
      ButlerHttp.post("HouseCustomer/update",{
        ...data
      },ret=>{
        that.getList();
      })
    },
    houseLegalToTempByHouseIds(urge_type=''){
      const that=this;
      if(!that.reginWhere.project_name){
        that.$message.error('请选择项目！');
        return false
      }
      if(!that.ch_md5s.length){
        that.$message.error('请勾选房产！');
        return false
      }
      that.loading = true;
      ButlerHttp.post("LegalHouse/lossHouseLegalToTempByHouseIds",{
        projectId:that.reginWhere.project_name,
        ch_md5s:that.ch_md5s.join(','),
        plan_urge_type:urge_type,
      }, res => {
        that.loading = false;
        if (res.code) {
          that.$message.success("操作成功")
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    houseLegalToTemp(){
      const that=this;
      if(!that.reginWhere.project_name){
        that.$message.error('请选择项目！');
        return false
      }
      let where = {
        ...that.where2,
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id
      }
      that.loading = true;
      ButlerHttp.post("LegalHouse/lossHouseLegalToTemp",{
        ...where,
      }, res => {
        that.loading = false;
        if (res.code) {
          that.$message.success("操作成功")
        }else {
          that.$message.error(res.msg);
        }
      });
    },
    handleSelectionChange(val) {
      const that=this;
      that.multipleSelection = val;
      // console.log('========>>>',that.tableKey,val.length);
      // TableData.getInstance().setList(that.tableKey,val)
      // console.log(TableData.getInstance().getTableData())
    },
    openLegalCase(){
      const that=this;
      if(!that.reginWhere.project_name){
        that.$message.error('请选择项目！');
        return false
      }
      if(!that.ch_md5s.length){
        that.$message.error('请勾选房产！');
        return false
      }
      let check = true;
      // this.multipleSelection.forEach(item => {
      //   if(item.is_complete != 1){
      //     check = false;
      //   }
      // })
      if(!check){
        that.$message.error("存在未完善资料的房产");
        return ;
      }

      this.law_case.visible = true;
      this.law_case.house_list = this.multipleSelection;
    },
    closeLegalCase(){
      this.law_case.visible = false;
    },
    exportData(is_all){
      const that=this;
      if(!that.reginWhere.project_name){
        that.$message.error('请选择项目！');
        return false
      }
      // that.$message.error('功能在完善中……');
      // return false
      let where = {
        ...that.where2,
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id,
        ch_md5s:that.ch_md5s.join(','),
        is_all:is_all
      }
      let loadingInstance = Loading.service({ fullscreen: true });
      ButlerHttp.post("HouseCustomer/exportExcel",{
        ...where
      },ret=>{
        if(ret.code){
          that.$socket.socket.on('LitigationHouseCustomer',(data)=>{
            let dataObj = JSON.parse(data.content);
            // console.log(dataObj)
            // dataObj.step;
            // dataObj.msg;
            if(dataObj.step==100){
              that.$message.success('生成成功');
              window.open(dataObj.msg);
              that.$socket.socket.off('LitigationHouseCustomer');
            }else if(dataObj.step==-1){
              that.$message.error('生成失败');
              that.$socket.socket.off('LitigationHouseCustomer');
            }
          })
        }
        loadingInstance.close()
      })
    }
  },
  computed:{
    ch_md5s(){
      return this.multipleSelection.map(ret=>ret.ch_md5)
    },
    selectCount(){
      return this.multipleSelection.length
    },
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_region":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.area_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.gj_time":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.month_count":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.cur_year_times":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.room_status":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.is_complete":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.is_case":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.is_apply":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.arrears_level1":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.arrears_level2":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.house_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
  }
}
</script>

<style lang="scss" scoped>
.el-button--primary,.el-button--success,.el-button--danger,.el-button--warning {
  color: #FFF;
}
.footer-pagination{
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/plan/LegalHouseCustomer.vue